import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import StandardTabPanel from "../../../../../components/ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../../../components/ui library/components/tab-panels/standard/tab-header/tab-styles";

const permissions = {
  general: "casemanager.view_case",
  coverage: "casemanager.view_clientcoverage",
  policy: "casemanager.view_clientpolicy",
  caseHealth: "core.view_auditflag",
};

export default function Navigation({ _case, activeTab, children }) {
  const currentUserService = inject("current-user-service");
  const userPermissions = currentUserService?.userRoles?.permissions || [];
  const canViewGeneral = userPermissions.includes(permissions.general);
  const canViewCoverage = userPermissions.includes(permissions.coverage);
  const canViewPolicy = userPermissions.includes(permissions.policy);
  const canViewCaseHealth = userPermissions.includes(permissions.caseHealth);

  const allTabs = [
    {
      key: "general",
      name: "General",
      isDisabled: !canViewGeneral,
      permission: permissions.general,
      href: `/client-detail/${_case.id}/case/general`,
    },
    {
      key: "coverage-and-liability",
      name: "Coverage & Liability",
      isDisabled: !canViewCoverage,
      permission: permissions.coverage,
      href: `/client-detail/${_case.id}/case/coverage-and-liability`,
    },
    {
      key: "policy-and-med-limits",
      name: "Policy & Med Limits",
      isDisabled: !canViewPolicy,
      permission: permissions.policy,
      href: `/client-detail/${_case.id}/case/policy-and-med-limits`,
    },
    {
      key: "property-damage",
      name: "Property Damage",
      isDisabled: !canViewGeneral,
      permission: permissions.general,
      href: `/client-detail/${_case.id}/case/property-damage`,
    },
    {
      key: "case-health",
      name: "Case Health",
      isDisabled: false,
      permission: canViewCaseHealth,
      href: `/client-detail/${_case.id}/case/case-health`,
    },
  ];

  return (
    <StandardTabPanel
      activeTab={activeTab}
      tabList={allTabs}
      headerTabSx={TAB_STYLES.SUB_TAB.SX}
      headerBoxBackgroundColor={"#FFFFFF"}
      headerTabIndicatorSx={TAB_STYLES.SUB_TAB.TAB_INDICATOR_SX}
    >
      <section className="m-4 h-auto max-h-[90vh] overflow-y-auto px-4 [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
        {children}
      </section>
    </StandardTabPanel>
  );
}
